import React, { useState } from 'react';
import { ArrowContainer, Popover } from 'react-tiny-popover';
import styled from 'styled-components';
import { HiOutlineDownload } from 'react-icons/hi';
import {
  SavedStrategies,
  SavedStrategy,
} from '@/features/editor/widgets/custom-widget/loading-section/strategy-per-slot/saved-strategy/saved-filters';

type Props = {
  onDeleteStrategy: (id: string) => void;
  setStrategy: (s: SavedStrategy) => void;
  strategies?: SavedStrategies;
};

export function LoadStrategy({
  setStrategy,
  onDeleteStrategy,
  strategies,
}: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const onSelect = (value: SavedStrategy) => {
    setIsOpen(false);
    setStrategy(value);
  };
  const onDelete = (e: any, id: string) => {
    e.stopPropagation();
    onDeleteStrategy(id);
  };
  return (
    <Popover
      onClickOutside={() => setIsOpen(false)}
      clickOutsideCapture
      positions={[`bottom`, `top`]}
      isOpen={isOpen}
      containerStyle={{ zIndex: `99999` }}
      content={({ position, childRect, popoverRect }) => (
        <ArrowContainer
          position={position}
          childRect={childRect}
          popoverRect={popoverRect}
          arrowColor="white"
          arrowSize={10}
          arrowStyle={{ margin: `1px` }}
        >
          <Strategies>
            {strategies && strategies.length > 0 ? (
              strategies.map((value) => (
                <Strategy key={value.id} onClick={() => onSelect(value)}>
                  <p>{value.name}</p>
                  <OptionBtn onClick={(e) => onDelete(e, value.id)}>
                    DELETE
                  </OptionBtn>
                </Strategy>
              ))
            ) : (
              <NoStrategy>No strategies have been saved</NoStrategy>
            )}
          </Strategies>
        </ArrowContainer>
      )}
    >
      <button type="button" onClick={() => setIsOpen(!isOpen)}>
        <HiOutlineDownload size={22} />
        <p>Load a Saved Strategy</p>
      </button>
    </Popover>
  );
}

const Strategy = styled.span`
  margin: 1.3rem 0 0 0;
  display: flex;
  width: 100%;
  justify-content: space-between;
  gap: 5px;

  & > p {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    margin: 0;
  }

  user-select: none;

  & > p:hover {
    cursor: pointer;
    opacity: 0.6;
  }

  & > p:active {
    cursor: default;
    opacity: 1;
  }
`;

const OptionBtn = styled.button`
  font-size: 1rem;
  padding: 0.2rem;
  opacity: 0.5;

  &:hover {
    cursor: pointer;
    opacity: 1;
  }
`;

const NoStrategy = styled.span`
  margin: 1.3rem 0 0 0;
  user-select: none;
`;

const Strategies = styled.div`
  font-family: 'Inter', serif;
  color: #8b97a2;
  font-weight: 500;
  font-size: 1.2rem;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  width: 30rem;

  padding: 1rem 2rem 2rem;
  border-radius: 10px;
  border: 1px solid rgba(151, 151, 151, 0.1);
  background-color: #ffffff;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.18),
    0 14px 16px 0 rgba(177, 217, 203, 0.18), 0 5px 16px 0 rgba(0, 0, 0, 0.05),
    0 -10px 10px -5px rgba(0, 0, 0, 0.1);
`;
